"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Notice {
    constructor(field) {
        var _a;
        this.field = field;
        this.notice = null;
        this.noticeMessageElement = null;
        this.noticeMessageSelector = '[data-js-notice-message]';
        this.errorMessage = "";
        this.noticeTemplate = this.field.querySelector('[data-js-file="notice-template"]');
        this.errorMessage = (_a = this.field.dataset.jsUploadErrorMessage) !== null && _a !== void 0 ? _a : 'Following files could not be uploaded';
    }
    /**
     * Show a notice with a message
     * @param message The message to display in the notice
     */
    showNotice(invalidFiles) {
        if (!this.noticeTemplate) {
            console.error("Notice template not found");
            return;
        }
        const notice = this.cloneNotice();
        const errorMessageElement = notice.querySelector(this.noticeMessageSelector);
        if (!errorMessageElement) {
            console.error(`Notice message element not found.`);
            return;
        }
        errorMessageElement.textContent = this.createErrorMessage(invalidFiles);
        this.field.prepend(notice);
        this.notice = notice;
        this.noticeMessageElement = errorMessageElement;
    }
    /**
     * Hide the notice element
     */
    hideNotice() {
        var _a;
        (_a = this.notice) === null || _a === void 0 ? void 0 : _a.remove();
        this.noticeMessageElement = null;
        this.notice = null;
    }
    /**
     * Create an error message from the invalid files
     * @param invalidFiles The list of invalid files
     * @returns A formatted error message
     */
    createErrorMessage(invalidFiles) {
        const fileNames = invalidFiles.map(file => file.name).join(', ');
        return `${this.errorMessage}: ${fileNames}`;
    }
    /**
     * Clones the notice element from the template.
     * @returns A cloned notice element from the template
     */
    cloneNotice() {
        const notice = this.noticeTemplate.content.cloneNode(true);
        return notice.firstElementChild;
    }
}
exports.default = Notice;
